import { formatDayTime, fullName } from "./resignationFormat";

const ICONS = {
  done: "fa fa-check",
  current: "fa fa-hourglass-half",
  waiting: "fa fa-circle",
  rejected: "fa fa-times",
  cancelled: "fa fa-ban",
  skipped: "fa fa-minus",
};

const approvalStep = (step, resignation) => {
  const approver = fullName(step.approver);
  const level = `Level ${step.approval_level}`;
  if (step.status === "approved") {
    return { tone: "done", title: `Approved by ${approver}`, meta: `${level} · ${formatDayTime(step.approved_on)}` };
  }
  if (step.status === "rejected") {
    return { tone: "rejected", title: `Rejected by ${approver}`, meta: `${level} · ${formatDayTime(step.approved_on)}` };
  }
  if (step.status === "skipped") {
    // Closed without a decision: HR decided first (e.g. the approver had left).
    return { tone: "skipped", title: `${approver} (not needed)`, meta: `${level} · ${formatDayTime(step.approved_on)}` };
  }
  const isCurrent =
    resignation.approval_status === "pending" && step.approval_level === resignation.approval_level;
  if (isCurrent) {
    return { tone: "current", title: `Awaiting ${approver}`, meta: `${level} · current approver` };
  }
  const meta = resignation.approval_status === "pending" ? "next in line" : "not reached";
  return { tone: "waiting", title: approver, meta: `${level} · ${meta}` };
};

const closingStep = (resignation) => {
  if (resignation.approval_status === "approved") {
    return { tone: "done", title: "Resignation approved", meta: formatDayTime(resignation.approved_on) };
  }
  if (resignation.approval_status === "cancelled") {
    return { tone: "cancelled", title: "Request cancelled", meta: "Withdrawn before a final decision" };
  }
  return null;
};

/** Submission, one row per approver in level order, then the outcome. */
export const buildTimeline = (resignation) => {
  const submittedBy = `by ${fullName(resignation.company_user)}`;
  const steps = [
    {
      key: "submitted",
      tone: "done",
      title: "Resignation submitted",
      meta: resignation.created_at ? `${formatDayTime(resignation.created_at)} · ${submittedBy}` : submittedBy,
    },
  ];
  [...(resignation.resignation_approval || [])]
    .sort((a, b) => a.approval_level - b.approval_level)
    .forEach((step) => steps.push({ key: `approval-${step.id}`, comment: step.comment, ...approvalStep(step, resignation) }));
  const closing = closingStep(resignation);
  if (closing) steps.push({ key: "closing", ...closing });
  return steps;
};

const ResignationTimeline = ({ resignation }) => (
  <ol className="resignation-timeline">
    {buildTimeline(resignation).map((step) => (
      <li key={step.key} className={`resignation-timeline__step is-${step.tone}`}>
        <span className="resignation-timeline__dot" aria-hidden="true">
          <i className={ICONS[step.tone]} />
        </span>
        <div className="resignation-timeline__body">
          <div className="resignation-timeline__title">{step.title}</div>
          <div className="resignation-timeline__meta">{step.meta}</div>
          {step.comment && <blockquote className="resignation-timeline__comment">{step.comment}</blockquote>}
        </div>
      </li>
    ))}
  </ol>
);

export default ResignationTimeline;
